<template>
  <div>
    <form v-if="!done" v-dropzone="dropzone" />
    <div v-if="done">
      <div class="alert alert-success">
        {{ message }}
      </div>
    </div>
    <!-- instructions -->
    <div class="alert alert-info">
      {{
        __(
          'Importante! O arquivo CSV com os dados usa o nome do lead como identificador, caso não exista, será criado um novo lead.',
        )
      }}
    </div>
  </div>
</template>

<script>
import Dropzone from 'dropzone';
import Integrations from '../../mixins/integrations';

export default {
  mixins: [Integrations],

  data() {
    return {
      done: false,
      message: '',
      config: {
        options: {
          all: false,
        },
      },
      integration: {
        name: 'pipedrive',
      },
      dropzone: {
        defaultMessage: 'Clique aqui ou arraste seu arquivo CSV para iniciar',
        action: '/pipedrive/csv/import',
        maxFilesize: 30,
        faIcon: 'fa-plus',
        success: this.fileUploadedCallback,
        error: this.fileUploadedError,
        keepFiles: false,
        acceptedFiles: '.csv, application/vnd.ms-excel, text/csv',
      },
    };
  },
  methods: {
    fileUploadedCallback(e) {
      this.done = true;
      if (e.xhr.status == 200) {
        Alert.success(this.__('Notas importadas.'));
        this.message = JSON.parse(e.xhr.response).message;

        return;
      }

      Alert.error(this.__('Problema ao importar Notas. Tente novamente'));
    },

    fileUploadedError(e) {
      if (!e.accepted) {
        Alert.error(this.__('Arquivo não aceito'));
        Dropzone.forElement('.dropzone').removeAllFiles();
        return;
      }
      if (e.xhr.status == 403) {
        const { error } = JSON.parse(e.xhr.response);

        if (error) {
          return Alert.error(error);
        }
      }

      Alert.error(this.__('Problema ao importar Notas. Tente novamente'));
    },
  },
};
</script>
